import { withStyles } from "@material-ui/core";
import { memo } from "react";
import SearchBar from "../../../../layout/layoutHeader/components/SearchBar";
import PlanDateHeader from "./PlanDateHeader";
import IBETACutoffInput from "../IBBills/IBBill/IBETACutoffInput";
import ShowHideColumns from '../../../../layout/layoutHeader/showHideColumns';
import { SaveAltSharp } from '@material-ui/icons';
import { csvFormulaInjectionSanitizer } from '../../../../utilities/csvUtils';
import Tooltip from '../../../common/StyledToolTip';
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';
import TrailerDetailsHeader from './TrailerDetailsHeader';

const styles = (theme) => ({
  container: {
    padding: '2px 20px 4px 24px',
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  searchContainer: {
    display: "flex",
    alignItems: "center",
  },
  title: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
    marginRight: 8,
  },
  rightSectionContainer: {
    display: "flex",
    alignItems: "center",
  },
  headerAction: {
    padding: 10, // Match ClearAllFilterButton padding to prevent ag-grid filter auto-close, Due to layout shift
    borderLeft: `1px solid ${theme.AppBGColor}`,
    cursor: 'pointer',
    color: theme.iconColor,
    zIndex: 100
  }
});
const GridHeader = ({
  glEventHub,
  headerId,
  title,
  classes,
  showIBETACutoff,
  onIBCutoffChanged,
  ibEtaCutOff,
  showPlanDate = true,
  gridApi,
  userProfile,
  exportFileName,
  trailerDetails,
  showTrailerDetails = false
}) => {
  const exportCSV = () => {
    if (!gridApi) {
      return;
    }
    const columnIds = gridApi.getColumns().reduce((columnKeys, column) => {
      if (column.colDef.headerName) {
        columnKeys.push(column.colId);
      }
      return columnKeys;
    }, []);
    const params = {
      fileName: exportFileName || title,
      columnKeys: columnIds,
      processCellCallback: (cell) => csvFormulaInjectionSanitizer(cell.value)
    };
    gridApi.exportDataAsCsv(params);
  };

  return (
    <div id="gridHeader" className={classes.container}>
      <div className={classes.searchContainer}>
        <span className={classes.title}>{title}</span>
        <SearchBar eventHub={glEventHub} headerId={headerId} />
      </div>
      <div className={classes.rightSectionContainer}>
        {showIBETACutoff && (
          <IBETACutoffInput onIBCutoffChanged={onIBCutoffChanged} ibEtaCutOff={ibEtaCutOff} />
        )}
        {showTrailerDetails && <TrailerDetailsHeader trailerDetails={trailerDetails} />}
        {showPlanDate && <PlanDateHeader />}
        <span className={classes.headerAction}>
          <ShowHideColumns api={gridApi} userData={{userProfile}} />
        </span>
        <span onClick={exportCSV} className={classes.headerAction}>
          <Tooltip title="Export Data">
            <SaveAltSharp />
          </Tooltip>
        </span>
        <ClearAllFilterButton gridApi={gridApi} />
      </div>
    </div>
  );
};

export default withStyles(styles)(memo(GridHeader));
